import React, {useState, useEffect} from 'react';
import Webpage from "./components/Webpage"
import './App.css'


function App() {

  return (
    <Webpage className="appContainer"/>
  );
}

export default App;